import micoImage1 from "../images/picsformicosite/MICO copyright designs (1).jpg";
import micoImage2 from "../images/picsformicosite/MICO copyright designs (2).jpg";
import micoImage3 from "../images/picsformicosite/MICO copyright designs (3).jpg";
import micoImage4 from "../images/picsformicosite/MICO copyright designs (4).jpg";
import micoImage5 from "../images/picsformicosite/MICO copyright designs (5).jpg";
import micoImage6 from "../images/picsformicosite/MICO copyright designs (6).jpg";
import micoImage9 from "../images/picsformicosite/MICO copyright designs (9).jpg";
import micoImage10 from "../images/picsformicosite/MICO copyright designs (10).jpg";
import micoImage11 from "../images/picsformicosite/MICO copyright designs (11).jpg";
import micoImage12 from "../images/picsformicosite/MICO Copyright designs (12).jpg";
import micoImage13 from "../images/picsformicosite/MICO Copyright designs (13).jpg";
import micoImage14 from "../images/picsformicosite/MICO Copyright designs (14).jpg";
import micoImage15 from "../images/picsformicosite/MICO Copyright designs (15).jpg";
import micoImage16 from "../images/picsformicosite/MICO Copyright designs (16).jpg";
import micoImage17 from "../images/picsformicosite/MICO Copyright designs (17).jpg";
import micoImage18 from "../images/picsformicosite/MICO Copyright designs (18).jpg";
import micoImage19 from "../images/picsformicosite/MICO Copyright designs (19).jpg";
import micoImage20 from "../images/picsformicosite/MICO Copyright designs (20).jpg";
import micoImage21 from "../images/picsformicosite/MICO Copyright designs (21).jpg";
import micoImage22 from "../images/picsformicosite/MICO Copyright designs (22).jpg";
import micoImage23 from "../images/picsformicosite/MICO Copyright designs (23).jpg";
import micoImage24 from "../images/picsformicosite/MICO Copyright designs (24).jpg";
import micoImage25 from "../images/picsformicosite/MICO Copyright designs (25).jpg";
import micoImage26 from "../images/picsformicosite/MICO Copyright designs (26).jpg";
import cherryLakeImage from "../images/picsformicosite/27 Cherry Lake design Pierce Pools ver 5-26-2025_004.jpg";
import alaDesignImage from "../images/picsformicosite/Ala_Design_-_3921_Brookwoods_Drive rec1_013.jpg";
import chapaImage from "../images/picsformicosite/Chapa -9554 LONGMIRE OAKS DRIVE - Pierce pools_048.jpg";
import davisImage from "../images/picsformicosite/Davis Pool Design - Barrett Pool rec_017.jpg";
import unnamedImage from "../images/picsformicosite/unnamed.jpg";
import image1 from "../images/3D/1015_Oak_Briar_Lane_2-Dr_Horton-NSP_004.jpg";
import image2 from "../images/3D/1015_Oak_Briar_Lane_2-Dr_Horton-NSP_008.jpg";
import image3 from "../images/3D/1015_Oak_Briar_Lane_2-Dr_Horton-NSP_011.jpg";

import image4 from "../images/3D/Ceulemans_Stefan_new_home-NSP_001.jpg";
import image5 from "../images/3D/Ceulemans_Stefan_new_home-NSP_003.jpg";
import image6 from "../images/3D/Ceulemans_Stefan_new_home-NSP_007.jpg";

import image7 from "../images/3D/Chumbley-NSP_new_design_005.jpg";
import image8 from "../images/3D/Chumbley-NSP_rec_2_009.jpg";
import image9 from "../images/3D/Chumbley-NSP_rec_2_016.jpg";
import image10 from "../images/3D/Chumbley-NSP_rec_2_021.jpg";

import image11 from "../images/3D/MICO_pool_samples(6).jpg";

import image13 from "../images/pool_vertical_1.jpg";
import image14 from "../images/pool_vertical_2.jpg";
import image15 from "../images/pool_vertical_3.jpg";

import image16 from "../images/3D/reggie/Reggie-IBP2_002.jpg";
import image17 from "../images/3D/reggie/Reggie-IBP2_004.jpg";
import image18 from "../images/3D/reggie/Reggie-IBP2_005.jpg";
import image19 from "../images/3D/reggie/Reggie-IBP2_007.jpg";
import image20 from "../images/3D/reggie/Reggie-IBP2_014.jpg";

export const GalleryImages = [
    {
        id: 1,
        imageSrc: micoImage1,
    },
    {
        id: 2,
        imageSrc: micoImage2,
    },
    {
        id: 3,
        imageSrc: micoImage3,
    },
    {
        id: 4,
        imageSrc: micoImage4,
    },
    {
        id: 5,
        imageSrc: micoImage5,
    },
    {
        id: 6,
        imageSrc: micoImage6,
    },
    {
        id: 7,
        imageSrc: micoImage9,
    },
    {
        id: 8,
        imageSrc: micoImage10,
    },
    {
        id: 9,
        imageSrc: micoImage11,
    },
    {
        id: 10,
        imageSrc: micoImage12,
    },
    {
        id: 11,
        imageSrc: micoImage13,
    },
    {
        id: 12,
        imageSrc: micoImage14,
    },
    {
        id: 13,
        imageSrc: micoImage15,
    },
    {
        id: 14,
        imageSrc: micoImage16,
    },
    {
        id: 15,
        imageSrc: micoImage17,
    },
    {
        id: 16,
        imageSrc: micoImage18,
    },
    {
        id: 17,
        imageSrc: micoImage19,
    },
    {
        id: 18,
        imageSrc: micoImage20,
    },
    {
        id: 19,
        imageSrc: micoImage21,
    },
    {
        id: 20,
        imageSrc: micoImage22,
    },
    {
        id: 21,
        imageSrc: micoImage23,
    },
    {
        id: 22,
        imageSrc: micoImage24,
    },
    {
        id: 23,
        imageSrc: micoImage25,
    },
    {
        id: 24,
        imageSrc: micoImage26,
    },
    {
        id: 25,
        imageSrc: cherryLakeImage,
    },
    {
        id: 26,
        imageSrc: alaDesignImage,
    },
    {
        id: 27,
        imageSrc: chapaImage,
    },
    {
        id: 28,
        imageSrc: davisImage,
    },
    {
        id: 29,
        imageSrc: unnamedImage,
    },
    {
        id: 30,
        imageSrc: image1,
    },
    {
        id: 31,
        imageSrc: image2,
    },
    {
        id: 32,
        imageSrc: image3,
    },
    {
        id: 33,
        imageSrc: image4,
    },
    {
        id: 34,
        imageSrc: image5,
    },
    {
        id: 35,
        imageSrc: image6,
    },
    {
        id: 36,
        imageSrc: image7,
    },
    {
        id: 37,
        imageSrc: image8,
    },
    {
        id: 38,
        imageSrc: image9,
    },
    {
        id: 39,
        imageSrc: image10,
    },
    {
        id: 40,
        imageSrc: image11,
    },
    // {
    //     id: 41,
    //     imageSrc: image12,
    // },
    {
        id: 42,
        imageSrc: image13,
    },
    {
        id: 43,
        imageSrc: image14,
    },
    {
        id: 44,
        imageSrc: image15,
    },
    {
        id: 45,
        imageSrc: image16,
    },
    {
        id: 46,
        imageSrc: image17,
    },
    {
        id: 47,
        imageSrc: image18,
    },
    {
        id: 48,
        imageSrc: image19,
    },
    {
        id: 49,
        imageSrc: image20,
    },
];
